
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class TechSpecsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(8 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;
        ctx.strokeStyle = pc.color;

        const drawSpec = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.globalAlpha *= 0.5;
             
             ctx.strokeRect(0, 0, s, s * 0.2);
             ctx.font = `${10 * scale}px monospace`;
             ctx.fillText("PARAMETER_BLOCK", 5, 12 * scale);
             
             for (let i = 0; i < 4; i++) {
                 const val = Math.floor(this.pseudoRandom(x + i) * 100);
                 ctx.fillText(`VAL_${i}: ${val}%`, 5, (25 + i * 12) * scale);
                 // Progress bar
                 ctx.strokeRect(60 * scale, (18 + i * 12) * scale, 30 * scale, 6 * scale);
                 ctx.fillRect(60 * scale, (18 + i * 12) * scale, 30 * scale * (val/100), 6 * scale);
             }
             ctx.restore();
        };

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 10) - 0.5) * height * 2;
                const rs = 100 * scale;
                // slow drift
                const dx = Math.sin(curTime * 0.1 + i) * 50;
                drawSpec(rx + dx, ry, rs);
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
